import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

type ShiftManageResponse = {
  shift_slot: number;
  main_code: string;
  codes: string[];
  manpower: number;
}[];

export function useShiftManageQuery(
  groupId: string,
  version: string = "default"
) {
  const base = `/shift-manage/RN?config_version=${encodeURIComponent(version)}`;
  const url = groupId
    ? `${base}&group_id=${encodeURIComponent(groupId)}`
    : base;

  return useQuery({
    queryKey: QUERY_KEYS.shifts.shiftManager(groupId, version),
    queryFn: async () => {
      return await httpClient.get<ShiftManageResponse>(url);
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
